export function formatForURL(url: string) {
  // Remove '%' characters which are not part of a valid URL encoding
  const cleanedUrl = url.replace(/%(?![0-9A-F]{2})/gi, "")

  return decodeURIComponent(cleanedUrl.toLowerCase())
    .replaceAll(/æ/g, "ae")
    .replaceAll(/å/g, "aa")
    .replaceAll(/ø/g, "oe")
    .replaceAll(/\s+/g, "-")
    .replaceAll(/[,;:]/g, "")
    .replaceAll(/-+/g, "-")
}

export function sanitizeForUrl(text: string | undefined) {
  if (!text) return ""

  const formatted = formatForURL(text)

  return formatted
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
}
